export const FACTOR_PX_MM = 0.2645833333;
export const FACTOR_MM_PX = 3.7795275591;
export const ZOOM = 0.1;
export const STROKE_WIDTH = 4;
export const MIN_STROKE_WIDTH = 1;
export const MAX_STROKE_WIDTH = 20;
export const TEXT_BACKGROUND = '#ffffff';
export const DEFAULT_FILL = '#cccccc';
export const TOOL_LINE_COLOR = '#18a0fb';
export const TEXT_COLOR = '#000000';
export const FONT = 'Calibri';
export const FONT_SIZE = 14; // px
export const MIN_FONT_SIZE = 4; // px
export const MAX_FONT_SIZE = 440; // px
export const TEXT_PADDING = 10;

export function getCrossLines(){
    return [
      {
        name: '',
        img:`vertical_lines.png?v=2`,
        thumbnail:`vertical_lines_thumbnail.jpg?v=2`
      }, 
      {
        name: '',
        img:`horizontal_lines.png?v=2`,
        thumbnail:`horizontal_lines_thumbnail.jpg?v=2`
      },
      {
        name: '',
        img:`left_diagonal_lines.png?v=2`,
        thumbnail:`left_diagonal_lines_thumbnail.jpg?v=2`
      },
      {
        name: '',
        img:`right_diagonal_lines.png?v=2`,
        thumbnail:`right_diagonal_lines_thumbnail.jpg?v=2`
      }
    ];
  };